import { render } from "./Athletics.vue?vue&type=template&id=be461c26&ts=true"
import script from "./Athletics.vue?vue&type=script&lang=ts"
export * from "./Athletics.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/vmchs.frontend/vmchs.frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__